import { render, staticRenderFns } from "./InsuranceProductModal.vue?vue&type=template&id=e179f476&"
import script from "./InsuranceProductModal.vue?vue&type=script&lang=js&"
export * from "./InsuranceProductModal.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceProductModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusIcon: require('/~/src/modules/opus/components/Icon.vue').default,ContentfulRichText: require('/~/src/modules/contentful/components/RichText.vue').default,OpusModalTwo: require('/~/src/modules/opus/components/ModalTwo.vue').default})
